import { render, staticRenderFns } from "./news-and-media-detail-page.vue?vue&type=template&id=11cebaf1&scoped=true"
import script from "./news-and-media-detail-page.vue?vue&type=script&lang=js"
export * from "./news-and-media-detail-page.vue?vue&type=script&lang=js"
import style0 from "./news-and-media-detail-page.vue?vue&type=style&index=0&id=11cebaf1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11cebaf1",
  null
  
)

export default component.exports